export function resolveTarget(target) {
  var _a, _b, _c;
  if (!target) return null;
  switch (target.type) {
    case "attr":
      return document.querySelector(target.selector);
    case "text": {
      const candidates = Array.from(document.querySelectorAll(target.selector));
      return (_a = candidates.find((el) => {
        var _a2, _b2;
        const text = (_b2 = (_a2 = el.textContent) == null ? void 0 : _a2.trim()) != null ? _b2 : "";
        if (target.textEquals) return text === target.textEquals;
        if (target.textIncludes) return text.includes(target.textIncludes);
        return false;
      })) != null ? _a : null;
    }
    case "iconText": {
      const candidates = Array.from(document.querySelectorAll("button, a"));
      return (_b = candidates.find((el) => {
        var _a2;
        return ((_a2 = el.textContent) == null ? void 0 : _a2.trim()) === target.iconGlyph;
      })) != null ? _b : null;
    }
    case "listIndex": {
      const items = Array.from(document.querySelectorAll(target.selector));
      return (_c = items[target.index]) != null ? _c : null;
    }
    default:
      return null;
  }
}
export function resolveTargetWithRetry(target, { intervalMs = 200, timeoutMs = 5e3 } = {}) {
  if (!target) return Promise.resolve(null);
  return new Promise((resolve) => {
    const start = Date.now();
    const tick = () => {
      const found = resolveTarget(target);
      if (found) {
        resolve(found);
        return;
      }
      if (Date.now() - start > timeoutMs) {
        resolve(null);
        return;
      }
      window.setTimeout(tick, intervalMs);
    };
    tick();
  });
}
